import { useCallback } from 'react';
import { useQuery } from 'data-fetching-client';
import getIn from 'immutable-less/transmute/getIn';
import { GET_OBJECT_TYPE_BY_ID } from 'automation-ui-references/object-type-properties/ObjectTypesQueries';
import { MULTI_GET_PROPERTIES } from 'automation-ui-log-events/api-client/queries/ObjectPropertiesQueries';
export const useGetSearchableFilterOptions = objectTypeId => {
  const {
    data
  } = useQuery(GET_OBJECT_TYPE_BY_ID, {
    variables: {
      objectTypeId
    }
  });
  const primaryDisplayLabelPropertyName = getIn(['objectTypeById', 'primaryDisplayLabelPropertyName'], data);
  const defaultSearchPropertyNames = getIn(['objectTypeById', 'defaultSearchPropertyNames'], data) || [];
  const shouldUseGenericQuery = !primaryDisplayLabelPropertyName || defaultSearchPropertyNames.includes(primaryDisplayLabelPropertyName);
  const {
    data: propertyData
  } = useQuery(MULTI_GET_PROPERTIES, {
    variables: {
      objectTypeId,
      propertyNames: [...defaultSearchPropertyNames, primaryDisplayLabelPropertyName]
    },
    skip: shouldUseGenericQuery
  });
  const getSearchableFilterOptions = useCallback(search => {
    if (shouldUseGenericQuery || !search) {
      return {
        query: search
      };
    }

    // Only add filterGroups for properties that are type-compatible with the
    // search query. Related:
    // https://issues.hubspotcentral.com/browse/WORKFLOWS-15110
    const propertiesCompatibleWithSearch = [...defaultSearchPropertyNames, primaryDisplayLabelPropertyName].filter(propertyName => {
      const type = getIn(['automation_ui_log_events_multiGetProperties', propertyName, 'property', 'type'], propertyData);
      if ((type === 'number' || type === 'dateTime' || type === 'date') && isNaN(Number(search))) {
        return false;
      }
      return true;
    });
    const filterGroups = propertiesCompatibleWithSearch.map(propertyName => ({
      filters: [{
        property: propertyName,
        value: search,
        operator: 'EQ'
      }]
    }));
    return {
      filterGroups
    };
  },
  // omitting primaryDisplayLabelPropertyName since it is derived from data
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [data, propertyData]);
  return {
    getSearchableFilterOptions,
    primaryDisplayLabelPropertyName
  };
};